import { escapeCsvCell } from "./earlyPayoutUtils";
import type { EarlyPayoutReportingRow } from "./earlyPayoutTypes";

export function formatBetCount(value: number): string {
  if (!Number.isFinite(value)) {
    return "0";
  }
  return new Intl.NumberFormat("en-US").format(value);
}

export function formatPayout(value: number): string {
  const amount = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

export function buildEarlyPayoutReportingCsv(
  rows: EarlyPayoutReportingRow[],
): string {
  const header = [
    "Sport",
    "League",
    "Market",
    "Matchup",
    "Time of Win",
    "Score on Win",
    "# of Bets",
    "Settled Payout",
  ];
  const lines = [header.map((label) => escapeCsvCell(label)).join(",")];

  for (const row of rows) {
    lines.push(
      [
        escapeCsvCell(row.sport),
        escapeCsvCell(row.league),
        escapeCsvCell(row.market),
        escapeCsvCell(row.matchup),
        escapeCsvCell(row.timeOfWin),
        escapeCsvCell(row.scoreOnWin),
        escapeCsvCell(formatBetCount(row.numberOfBets)),
        escapeCsvCell(formatPayout(row.settledPayout)),
      ].join(","),
    );
  }

  return lines.join("\n");
}
